import React, { Component } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import Button from "@material-ui/core/Button";
import {
	getStoredConsent,
	grantAnalyticsConsent,
	denyAnalyticsConsent
} from "../analytics";

// Cookie-consent bar for GA4 Consent Mode. Shown only until the visitor makes a
// choice (stored in localStorage); analytics stays denied until they Accept.
class ConsentBanner extends Component {
	constructor(props) {
		super(props);
		// Only prompt when no prior choice exists.
		this.state = {
			open: getStoredConsent() === null
		};
		this.handleAccept = this.handleAccept.bind(this);
		this.handleDecline = this.handleDecline.bind(this);
	}

	handleAccept() {
		grantAnalyticsConsent();
		this.setState({ open: false });
	}

	handleDecline() {
		denyAnalyticsConsent();
		this.setState({ open: false });
	}

	render() {
		return (
			<Snackbar
				open={this.state.open}
				anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
				// Sit above the fixed footer AppBar (which has no explicit z-index).
				style={{ zIndex: 1400, bottom: "88px" }}
			>
				<SnackbarContent
					style={{ backgroundColor: "#585A5C", maxWidth: "560px" }}
					message={
						<span>
							We use cookies for anonymous traffic analytics to understand how
							visitors find Newfangle Press. Nothing is stored until you accept.
						</span>
					}
					action={[
						<Button
							key="decline"
							color="inherit"
							size="small"
							onClick={this.handleDecline}
						>
							Decline
						</Button>,
						<Button
							key="accept"
							size="small"
							style={{ color: "#f1f3f4", fontWeight: "bold" }}
							onClick={this.handleAccept}
						>
							Accept
						</Button>
					]}
				/>
			</Snackbar>
		);
	}
}

export default ConsentBanner;
